<template>
    <div class="signin-bg">
        <Header></Header>
        <!--搜索-->
        <div class="w-95p">
            <div class="serch">
                <!--下拉框区域-->
                <div class="dropdown">
                    <div class="xiala">
                        <span>{{searchActive}}</span>
                        <img src="../assets/search/dow.png" alt=""/>
                        <dl class="dropdown_menu">
                            <b class="top"><i class="top-arrow1"></i><i class="top-arrow2"></i></b>
                            <dd>
                                <a href="javascript:;" @click="selectMenu($event)" data-num='1'>摄影图片</a>
                            </dd>
                            <dd>
                                <a href="javascript:;" @click="selectMenu($event)" data-num='2'>矢量图片</a>
                            </dd>
                            <!--<dd>
                                <a href="javascript:;" @click="selectMenu($event)" data-num='0'>优质视频</a>
                            </dd>-->
                        </dl>
                    </div>

                </div>
                <!--搜索框-->
                <div class="inpt-95p">
                    <!--<img src="../assets/search/xj.png" alt=""/>-->
                    <input type="text" placeholder="  搜索照片、矢量图和视频，多个词注意用空格分隔" v-model="keyword" @keyup.enter="getSearchList(1)"/>
                </div>
                <!--搜索图标-->
                <div class="icon-scrch" @click.prevent="getSearchList(1)">
                    <img src="../assets/search/ss1.png" alt=""/>
                </div>
            </div>
        </div>
        <!--搜索条件选择-->
        <div class="continer flstart w-95p">
            <div class="paixu hd">
                <span class="fl">排序：</span>
                <p @click="selectOrderBy($event)" data-num='1' :class="{'act':(orderBy == '1')}">全部<i></i></p>
                <p @click="selectOrderBy($event)" data-num='3' :class="{'act':(orderBy == '3')}">热门<i></i></p>
                <p @click="selectOrderBy($event)" data-num='2' :class="{'act':(orderBy == '2')}">最新<i></i></p>
            </div>
            <div class="tiaojian">
                <span class="fl">筛选条件：</span>
                <div class="juti-tj fl pr">
                    <div class="sxall">
                        <p class="tj-cont">{{sizeTxt}}</p>
                        <img src="../assets/search/dow.png" alt=""/>
                        <div class="tj-dow pa" tag="解析度">
                            <a href="javascript:;" @click="selectSize($event)" data-num='0'>全部</a>
                            <a href="javascript:;" @click="selectSize($event)" data-num='720'>720P</a>
                            <a href="javascript:;" @click="selectSize($event)" data-num='1080'>1080P</a>
                            <a href="javascript:;" @click="selectSize($event)" data-num='4K/UHD'>4K/UHD</a>
                        </div>
                    </div>

                </div>
                <div class="juti-tj fl pr">
                    <div class="sxall">
                        <p class="tj-cont">{{fpsTxt}}</p>
                        <img src="../assets/search/dow.png" alt=""/>
                        <div class="tj-dow pa" tag="FPS">
                            <a href="javascript:;" @click="selectFps($event)" data-num='23.98/24'>23.98/24</a>
                            <a href="javascript:;" @click="selectFps($event)" data-num='25'>25</a>
                            <a href="javascript:;" @click="selectFps($event)" data-num='29.97/30'>29.97/30</a>
                            <a href="javascript:;" @click="selectFps($event)" data-num='60'>60</a>
                            <a href="javascript:;" @click="selectFps($event)" data-num='>60'>>60</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--筛选标签-->
        <ul class="ul-tag">
            <li v-show="tagListSize">
                <span>{{tagListSize.name + '：' + tagListSize.val}}<i @click="changeSize()">x</i></span>
            </li>
            <li v-show="tagListFps">
                <span>{{tagListFps.name + '：' + tagListFps.val}}<i @click="changeFps()">x</i></span>
            </li>
        </ul>

        <div class="gjcpubuliu" v-if="!isLoad">
            <div class="w-95p" v-if="!isResult">
                咦，未搜到您要找的视频，
                建议您换个同义关键词或者缩短关键词试试哦
            </div>
            <div class="w-95p" v-if="isResult">
                <!--关键词-->
                <div class="nav-top flbt">
                    <div class="gjc-font">
                        <span>关键词：</span>
                        <span class="serch-gjc">{{keyword}}</span>
                        <span>共为您找到</span>
                        <span class="jieguo-num">{{searchList.total}}</span>
                        <span>个作品</span>
                    </div>
                    <pagination :pcurrentPage='currentPage' :ptotal='searchList.pages' @on-result-change="onResultChange"></pagination>
                </div>
                <!--图片瀑布流-->
                <div class="pubu-img">
                    <div v-for="(item,index) in searchList.footage" :key="index" :style="{width:(200/item.height)*item.width + 'px',background:'#bbbbbb'}">

                            <router-link :to="{name:'VideoDetail',query:{id:item.id}}" target="_blank">
                                <img v-lazy="item.link_image" />
                            </router-link>


                    </div>
                </div>
                <!--上一页下一页-->
                <pagination class="mt25" :pcurrentPage='currentPage' :ptotal='searchList.pages' :prevnext='true' @on-result-change="onResultChange"></pagination>
            </div>
        </div>
        <loading v-if="isLoad"></loading>
        <Footer></Footer>
    </div>
</template>

<script>

    import Header from './Header';
    import Footer from './Footer';
    import Pagination from '../components/Pagination';
    export default {
        name: 'Register',
        data() {
            return {
                searchActive:'优质视频',
                sizeTxt:'解析度',
                fpsTxt:'FPS',
                keyword:'',
                size:0,
                fps:0,
                mediaType:0,
                orderBy:1,
                currentPage:1,
                searchList:[],
                isLoad:false,
                isResult:false,
                tagListSize:false,
                tagListFps:false,
            }
        },
        components:{
            Header,
            Footer,
            Pagination
        },
        created() {
           this.keyword = this.$route.query.keyword
           window.document.title = "神笔Pro - 优质视频,"+this.keyword
        },
        mounted() {
            this.getSearchList()
        },
        methods: {
            onResultChange(val){
                this.currentPage = val
                this.getSearchList(val)
            },
            changeFps(){
                this.fpsTxt = 'FPS',
                this.tagListFps = !this.tagListFps
                this.getSearchList(this.currentPage)
            },
            changeSize(){
                this.sizeTxt = '解析度',
                this.tagListSize = !this.tagListSize
                this.getSearchList(this.currentPage)
            },
            selectMenu(e){
                this.searchActive = e.target.innerText
                this.mediaType = e.target.getAttribute('data-num')
                this.getSearchList(this.currentPage)
                window.document.title = "神笔Pro - 优质视频,"+this.keyword
            },
            selectOrderBy(e){
                this.orderBy = e.target.getAttribute('data-num')
                this.getSearchList(this.currentPage)
            },
            selectSize(e){
                this.sizeTxt = e.target.innerText
                this.size = e.target.getAttribute('data-num')

                this.tagListSize = {}
                this.tagListSize = {name:e.target.parentNode.getAttribute('tag'),val:this.size}

                this.getSearchList(this.currentPage)
            },
            selectFps(e){
                this.fpsTxt = e.target.innerText
                this.fps = e.target.getAttribute('data-num')

                this.tagListFps = {}
                this.tagListFps = {name:e.target.parentNode.getAttribute('tag'),val:this.fps}

                this.getSearchList(this.currentPage)
            },
            prevPage(){
                this.currentPage--;
                this.getSearchList(this.currentPage)
            },
            nextPage(){
                this.currentPage++;
                this.getSearchList(this.currentPage)
            },
            getSearchList(currentPage){
                this.isResult = false
                if(!this.keyword){
                    this.$message({
                        message: '请输入关键字',
                        type: 'error'
                    });
                    return
                }
                if(this.mediaType != 0){
                    this.$router.push({name:'Search',query:{keyword:this.keyword,mediaType:this.mediaType}})
                }
                this.isLoad = true
                let data = {
                    keyword:this.keyword,
                    order:this.orderBy,
                    size:this.size,
                    fps:this.fps,
                    page:currentPage,
                    pageNum:30,
                }
                this.$post('/footage/search',data)
                    .then( res => {
                        if(res.code == 200){
                            this.isLoad=false
                            if(res.data.result.footage.length > 0){
                                this.isResult=true
                                this.searchList = res.data.result
                            }
                        }else{
                            this.$message({
                                message: res.message,
                                type: 'error'
                            });
                        }

                    }).catch(error => {
                    console.log(error)
                })
            }
        }
    }
</script>


<style scoped>
    body {  font-family: "Source Han Sans CN",Arial,sans-serif;  font-size: 16px;  }
    * {  padding: 0; margin: 0; box-sizing: border-box; }
    a {text-decoration: none;color:#333;  }
    div, b, p, h1, h2, h3, h4, h5, h6,ul, li, dl, dd, header, footer {  margin: 0;  padding: 0;  list-style: none;  }
    em, i, b, strong {font-style: normal;font-weight: normal;}
    .ct{text-align: center;}
    .fl{float: left}
    .fr{float: right}
    .pr{position: relative}
    .pa{position: absolute}
    .hd{overflow: hidden;}
    .flard{display: flex;justify-content: space-around;}
    .flbt{display: flex;justify-content: space-between;}
    .flstart{display: flex;justify-content: start;}
    .w-1200{width: 1200px;margin: 0 auto;}
    .w-1190{width: 1190px;margin: 0 auto;}
    .w-95p{width: 95%;margin: 0 auto;}
    .mt25{margin-top: 25px}
    /*ͷ������*/
    img{vertical-align: top;}
    .header .logo{margin-top: 16px;}
    .nav li{margin: 0 20px;text-align: center;}
    .nav li.active::after{content:"";display:block;background: #FF9F00;height: 2px;width:80%;margin: -15px auto 0; }
    .nav li.active{font-weight: 600;}
    .loging .kefu img,.loging .tishi img{margin: 17px 20px 0;}
    .tishi{position: relative;}
    .tishi span.num{position: absolute;background: #E74C3A;border-radius:10px;color: #fff;min-width: 20px;height: 20px;font-size: 14px;text-align: center;line-height: 20px;display: inline-block;top:15px;right: 15px;padding: 0 4px;}
    .loging .user-down img{margin: 30px 10px 0}
    .user-down{cursor: pointer;position: relative;}
    .jiantou{ transform: rotate(180deg); -webkit-transform: rotate(180deg)}
    /*�ײ�*/
    footer{height: 180px;background: #fff;padding: 70px 0 0;}
    footer p{font-size: 12px;color: #999;text-align: center;}
    .serch{background: #f7f7f7;display: flex;justify-content: space-between;height: 50px;border-bottom: 2px solid #1F1F1F;}
    .xiala{font-size: 16px;}
    .xiala:hover > .dropdown_menu{display: block}
    .dropdown{width: 140px;text-align: center;line-height: 48px;cursor: pointer;}
    .inpt{width: 950px;padding-right: 10px;position: relative;}
    .inpt-95p{width: 95%;padding-right: 10px;position: relative;}
    input{border: none;height: 48px;line-height: 48px;width: 100%;/*padding-left:40px;*/outline:none;font-size: 16px;background: #f7f7f7;}
    input::-webkit-input-placeholder {color:#999999; font-size: 16px; }
    input:-moz-placeholder {color:#999999; font-size: 16px; }
    input::-moz-placeholder {color:#999999;font-size: 16px;  }
    input:-ms-input-placeholder {color:#999999; font-size: 16px; }
    .icon-scrch{width: 110px;text-align: center;cursor: pointer;}
    .icon-scrch img{margin-top: 13px;cursor: pointer;}
    /*������*/
    .xiala img{margin-top: 17px;}
    .inpt img{margin-top: 12px;position: absolute;}
    .inpt-95p img{margin-top: 12px;position: absolute;}
    .dropdown {position: relative;}
    .dropdown_menu {display: none;background: #f7f7f7;position: absolute;top:48px;right: 30px;z-index: 1000;width: 110px;padding:10px 0;text-align: center;border-top: 1px solid #ddd;}
    .dropdown_menu dd{line-height: 34px!important;}
    .dropdown_menu dd:hover{background: #e0e0e0;}
    .dropdown dl dd a {color: #333;line-height: 34px;font-size:14px;}
    .top-arrow1,.top-arrow2 {width:0;height:0;display:block;position:absolute;left:30px;top:-17px;z-index:5; /*����ie8-*/ border-top:8px transparent dashed;border-left:6px transparent dashed;border-right:6px transparent dashed;border-bottom:8px white solid;overflow:hidden;}
    .top-arrow1 {border-bottom:9px #ddd solid;}
    .top-arrow2 {top:-15px;border-bottom:9px #f7f7f7 solid;}
    /*��������*/
    .continer{padding: 30px 0 15px;}
    .paixu{width: 200px;}
    .tiaojian{width: 980px;}
    .paixu p{float:left;margin-right: 15px;cursor: pointer;}
    .paixu .act{font-weight: 600; }
    .paixu .act i{display:block;height: 2px;width:28px;margin: 2px auto 0px;background: #000; }
    .tiaojian div.fl{margin-right: 30px;}
    .sxall{cursor: pointer;height: 30px;}
    .sxall p{display: inline-block;}
    .sxall img{vertical-align: middle;margin-left: 5px;}
    .tj-dow{background: #fff;top:30px;left: 0;width:110px;border: 1px solid #ddd;display: none;}
    .tj-dow a{display: block;height: 36px;line-height: 36px;}
    .tj-dow a:hover{background: #ddd;}
    .sxall:hover > .tj-dow{
        display: block;
    }
    .gjcpubuliu{background: #F7F7F7;padding: 30px 0;}
    .nav-top{margin:0 5px 20px;}
    .serch-gjc{display: inline-block;margin-right: 20px;}
    .jieguo-num{font-weight: 600;display: inline-block;margin: 0 3px;}
    .page{font-size: 14px;}
    .page .dqye{width: 50px;border-bottom: 1px solid #000000;text-align: center;font-weight: 600;}
    .zuo img,.you img{width: 14px;height: 14px;cursor: pointer;}
    .you img{transform: rotate(180deg); -webkit-transform: rotate(180deg)}
    .allpage{margin: 0 10px;}
    /*ͼƬ�ٲ���*/
    .pubu-img{display: flex;flex-wrap: wrap;}
    .pubu-img:after{content: ' ';flex-grow: 9999999999;}
    .pubu-img img{height: 200px;width: auto;margin: 5px;flex-grow: 1;/*���а���������*/object-fit: cover;/*���в��У�����ͼƬ����������*/}
    /*��һҳ��һҳ*/
    .btn{width:285px;margin: 0 auto }
    .btn a{display: inline-block;width: 130px;height: 40px;line-height: 40px;border-radius: 23px;text-align: center;border: 1px solid#000;font-size:18px;margin: 0 5px;}
    .page-btm{margin-top: -30px;}
    /*�ײ��ؼ���*/
    .gjc-btm{margin-top: 60px;}
    .gjc-btm p{font-size: 18px;font-weight: 600;margin-bottom: 25px;}
    .gjc-contbg a{float:left;background: #fff;height: 30px;line-height: 30px;padding: 0 10px;border-radius: 5px;font-size: 14px;color: #999;margin-right: 8px;margin-bottom: 10px;}

    .ul-tag{
        width: 1200px;
        margin: 0 auto;
        display: flex;

    }
    .ul-tag li{
        margin: 0 5px 10px;
    }
    .ul-tag li span{
        position: relative;
        background-color: #f4f4f5;
        color: #909399;
        display: inline-block;
        width: auto;
        height: 36px;
        line-height: 36px;
        border-radius: 4px;
        font-size: 14px;
        padding: 0px 30px 0px 15px;
    }
    .ul-tag li span i{
        position: absolute;
        content: 'x';
        display: inline-block;
        font-size: 18px;
        right: 15px;
        cursor: pointer;
    }
</style>
